export const ENTREPRENEURS_SLUG = "pujcka-pro-podnikatele"

export const entrepreneursOverrides = {
  primaryButtonText: "Chci financování",
  heroTitle: "Spolehlivá půjčka pro podnikatele a OSVČ",
  answerDescriptions: {
    1: "Plnoletí podnikatelé a OSVČ s aktivním bankovním účtem a telefonem."
  } as Record<number, string>,
  why: {
    description: "Pomáháme živnostníkům a podnikatelům najít férové financování. Hlavní důvody, proč se na nás můžete spolehnout:",
    cardDescriptions: {
      1: "Úvěr dostupný pro podnikatele napříč obory",
      3: "Rychlá výplata je jednou z našich hlavních výhod",
      4: "Ve spolupráci s ověřenými partnery pomáháme firmám a OSVČ najít optimální variantu financování"
    } as Record<number, string>
  },
  forWhat: {
    title: "Půjčku lze využít na cokoliv,\nco vaše podnikání potřebuje",
    cardTitles: {
      1: "Vybavení a technika",
      2: "Provozní výdaje",
      3: "Překlenutí výpadku příjmů",
      4: "Rozvoj podnikání"
    } as Record<number, string>
  },
  about: {
    tableHeader: "GOODFIN",
    questionOverrides: {
      3: "Doba splácení"
    } as Record<number, string>
  }
}
